import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/store';

export const messageSelector = createSelector(
  (state: RootState) => state.ui.message,
  (message) => message,
);
